var _rect, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApprovedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.804688,
    y: 0.96875,
    width: 16.3938,
    height: 16.0631,
    fill: "url(#pattern0_2039_23122)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.804688,
    y: 0.96875,
    width: 16.3938,
    height: 16.0631,
    fill: "url(#pattern1_2039_23122)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2039_23122",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2039_23122",
    transform: "matrix(0.00979828 0 0 0.01 0.0100862 0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_2039_23122",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_2039_23122",
    transform: "matrix(0.00979828 0 0 0.01 0.0100862 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2039_23122",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAABaUlEQVR4nO3ay0kEQRiF0QYTUHSvCEZqKEZgHLqoDMQ8hCvjC0HFQXTqOn3OuhfFfFVM9U8vCwAAAAAAAAAAMFGS4yTXSc5mroPlKcZRkts8u09y7ofpiPFKlKIYohTGEGXCH/jIdu6SnO50gWuS7U7Ge5twJ7PXvZciRg8xiohRRIwiYhQRo4gYReJq2yNi9IgYPSJGj4jRI2L0iBg9IkaPiNEjYvSIGD0iRo+I0SNi9MiaYyQ5SHK5+V5p+X/fTeXl2Yq1/1aMq5ZdFifjLUZmR4kYH2JMixIxvoyx8ygR49sYO4uSNcfYSHLYcoPJmm9Tn+zKm5m7Mms/GU1RIkZPlIjREyVi9ESJGD1RIkZPlIjREyVi9ESJGD1RIkZVlAtv4H/oB/Omh6x9NlV4Urax37OpfxZliNETZYjRE2WI0RNliNETZYjRE2WI0RNliNETZYjRE2WI0TNmuTIOAQAAAAAAAGCZ6xFEa/nhIJ9GHwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_2039_23122",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAxJJREFUeF7t3M1NAzEUBOCJaABEIRygABC0wI0eoARKoALEjR5ASLRAAwg4QwlIxCIRqyXZfV7/zdqTKxvn8b6MvWssFtCLqgMLqmpUDARC9iUQiEDIOkBWjhIiELIOkJWjhAiErANk5SghAiHrAFk5SohAyDpAVo4SIhCyDpCVo4QIhKwDZOUoIQIh6wBZOUqIQMg6QFaOEiIQsg7ELWcfwC2ASwBvU4ZWQqZ0bfN79gA8AjgE8AHgBMCr7/AC8e3YOMb6ikkoAgkH6SajP5o3ikDCQIYwJiVFINNB3AL+BODAMIRb4I8BvI9dK5CxDtnXjKGRXgCcAfgc+ziBjHXo/88t01T3XWYM9yaB+IEkxRAIGYZA7CDJk7EuRVPWOEo2DCWEDEMgwyBZk6EpixBDCcn80Dc+Q+o5pN+jItNUtwjdZf11oziGpiwyDIH8glAkQ3dZhBitJ4QqGa0nhBKj1YTQYrQIQo3RGgg9Rksgs8BoBWQ2GC2AzAojNsjOcsBrADcAviw7m4mv8Tk35Upxp0NOS9cea3PRYdwBuFj9YqYzSAlBZpeMmA+GXYz1uF5nkSLDzBYjxpS1CaMkyqwxQkGGMEqgzB4jBMSCkROlCowQkN3lae5n48nv1Hcws7yb2rZuhtxluW/lA4Aj46KcYqGvJhmx7rJKolSHETJldUNRAqVKjFggbpycKNVixATJhVI1RmyQ1CjVY6QASYXSBEYqkNgozWCkBImF0hRGapBQlOYwcoBMRTkHcL/6Ry6WjYAUuwCWz41+TcjWiU8xvvtN3wDcBqblRfGXPkuhlmtygUxJiqX+apIRay/L0rSQbZah8avDyLWG9Jvqu82yCaVKjFIgodNXtRglQaaiVI1RGsQXpXoMBhArShMYLCBjKM1gMIFsQ2kKgw2kj9IcBiOIq8lts7gD21elDz77PvXGuD7n1kmMeqsfQyBkxAIRCFkHyMpRQgRC1gGycpQQgZB1gKwcJUQgZB0gK0cJEQhZB8jKUUIEQtYBsnKUEIGQdYCsHCVEIGQdICtHCSED+QGcCORl6+7gwQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedIcon);
export default __webpack_public_path__ + "static/media/approvedIcon.a53b1960a6a59c23d9143cd9b5dddc0a.svg";
export { ForwardRef as ReactComponent };